module.exports = __webpack_public_path__ + "static-v-shop/1792771651670/img/logo_visadebito.092f0267.png";